module.exports = "/img/search_purple.svg?d23827e74c8b60a48101e2abda24f6b6";